"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Informer = _interopRequireDefault(require("./Informer.js"));
exports.default = _Informer.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }